export default __webpack_public_path__ + "static/media/prt_qr_example.7fad26f4.jpg";